import http from "../../../service/axios/httpRequest";
import { logout } from "../../../service/localStorage/localStorage";

export const getAllInvitesRequest = async () => {
     return await http.get("/bff/aux-bff/list-all-invites-business-with-plan").then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               throw err;
          });
}

export const EditPlansRequest = async (body) => {
     return await http.put("/bff/plan-bff", body).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               alert(err.response.data.message)
               throw err;
          });
}

export const DeleteInviteRequest = async (id) => {
     return await http.delete("/bff/aux-bff/delete-invite-business-with-plan/"+id,
          
     ).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }
               alert(err.response.data.message)
               throw err;
          });
}

export const CreateInvitesRequest = async (body) => {
     return await http.post("/bff/aux-bff/generate-invite-business-with-plan", body).then(response => response.data)
          .catch(err => {
               if (err.response.status === 401) {
                    logout()
                    window.location.reload()
               }

               alert(err.response.data.message)
               throw err;
          });
}


 export const generatelink = async (rowData) => {
        return await http.get("/bff/aux-bff/generate-link-business-invite?verifyTokenId=" + rowData.id).then(response => response.data);
    }